exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score-modal .content{padding:0}.score-modal .dialog{background-color:transparent;border:none;box-shadow:none}.score-modal .dialog .modal-head .close-icon{top:40px}.score-modal .dialog .modal-head .close-icon svg{fill:#fff;width:17px;height:17px}", ""]);

// exports
